/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { defaultTheme } from '@vital-ui/react-theme';
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  background-color: ", ";\n  color: ", ";\n  font-size: 0.93333rem;\n  padding: 10px;\n"], ["\n  display: block;\n  background-color: ", ";\n  color: ", ";\n  font-size: 0.93333rem;\n  padding: 10px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.tab.panel.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.tab.panel.color;
});
Root.defaultProps = {
    theme: defaultTheme,
};
var TabPanel = /** @class */ (function (_super) {
    __extends(TabPanel, _super);
    function TabPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabPanel.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style;
        return (React.createElement(Root, { className: cn('vital__tab-panel', className), style: style }, this.props.children));
    };
    return TabPanel;
}(React.Component));
export default TabPanel;
var templateObject_1;
//# sourceMappingURL=TabPanel.js.map